import Upload from '@/app/_components/ui/icons/Upload.svg';
import Trash from '@/app/_components/ui/icons/Trash.svg';
import Image from 'next/image';
import React from 'react';

export default function FilesInput(props) {
  const {
    register,
    errors,
    name,
    label,
    description,
    required,
    onchange,
    files,
    deleteFile,
  } = props;
  return (
    <>
      <div className="flex border border-dashed border-light-gray-300 p-5 rounded-md cursor-pointer ">
        <div className="pl-2">
          <Upload />
        </div>
        <div>
          <label htmlFor="file-upload" className="cursor-pointer">
            {label}
            {required && <span className="text-red-500">*</span>}
          </label>
          <input
            id="file-upload"
            type="file"
            className="hidden"
            onChange={onchange}
          />
          <div className="">
            <span className="text-tiny text-gray-800 ">{description}</span>
          </div>
        </div>
      </div>
      <div className="flex preview mt-2 ">
        {files.length > 0 &&
          files.map((item, index) => {
            return (
              <div key={item} className="relative ml-2">
                <Image
                  width="56"
                  height="56"
                  className="rounded-md"
                  src={item}
                  alt=""
                />
                <button
                  className="absolute p-1 bg-gray-900 bottom-2.5 left-1 rounded-sm"
                  type="button"
                  onClick={() => deleteFile(index)}
                >
                  <Trash fill="#fff" />
                </button>
              </div>
            );
          })}
      </div>
    </>
  );
}
